import type { EcReceiptDetail_ManagementEcPageQuery } from "@/lib/gql/__generated__/graphql";

import type { ViewData } from "../../type";

type Props = {
	queryData: EcReceiptDetail_ManagementEcPageQuery;
};

export const convertQueryDataToViewData = ({
	queryData: {
		ecReceiptItem,
		voucherIssuedByHotelIDAndReceiptID: { voucherIssuedList },
	},
}: Props): ViewData => {
	if (!ecReceiptItem) throw new Error("ecReceiptItem is undefined");

	const {
		hotelID,
		receiptID,

		guestName,
		guestNameKana,
		guestPostalCode,
		guestAddress,
		guestEmail,
		guestTel,

		purchasedDate,
		purchasedItems,
		totalGuestCharge,
	} = ecReceiptItem;

	return {
		ecReceiptItem: {
			hotelID,
			receiptID,

			guestName,
			guestNameKana: guestNameKana ?? "",
			guestPostalCode,
			guestAddress,
			guestEmail,
			guestTel,

			purchasedDate,
			purchasedItems,
			totalGuestCharge,
		} satisfies ViewData["ecReceiptItem"],

		voucherIssuedList: voucherIssuedList.map((voucher) => {
			return {
				hotelID: voucher.hotelID,
				usedReservationID: voucher.usedReservationID ?? "",
				userECReceiptID: voucher.userECReceiptID,

				voucherMast: {
					name: voucher.voucherMast.name,
					description: voucher.voucherMast.description,
					voucherPrice: voucher.voucherMast.voucherPrice,
					sellingPrice: voucher.voucherMast.sellingPrice,
				},

				voucherCode: voucher.voucherCode,

				isUsed: !!voucher.usedAt,

				cinStart: voucher.cinStart ?? "",
				cinEnd: voucher.cinEnd ?? "",

				giftInfo: voucher.giftInfo
					? {
							from: voucher.giftInfo.from,
							to: voucher.giftInfo.to,
							message: voucher.giftInfo.message ?? "",
							password: voucher.giftInfo.password,
						}
					: undefined,

				guestName: voucher.guestName,
				guestAddress: voucher.guestAddress,
				guestEmail: voucher.guestEmail ?? "",
				guestPostalCode: voucher.guestPostalCode,
				guestTel: voucher.guestTel,

				useableStartDt: voucher.useableStartDt,
				usedAt: voucher.usedAt ?? undefined,

				createdAt: voucher.createdAt,
				createdDt: voucher.createdDt,
			} satisfies ViewData["voucherIssuedList"][number];
		}),
	} satisfies ViewData;
};
